import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { selectHand } from '../ActiveGame/selectors';
import { setContextMenu } from '../ActiveGame/actions';
import { HAND } from '../ActiveGame/contextMenuTypes';
import CardFace from '../Card/CardFace';
import { PlainButton } from '../Controls';
import ContextMenu from '../ContextMenu';
import CardDetail from '../ContextMenu/CardDetail';
import HandMenu from './HandMenu';
import { Label, Tray } from './styled';

/** Your hand, always on screen. Tapping a card opens what you can do with it. */
const Hand = ({ userId }) => {
  const dispatch = useDispatch();
  const hand = useSelector((state) => selectHand(state, { userId }));
  const [chosenPivotId, choose] = useState(null);

  if (!hand) {
    return null;
  }

  const cards = hand.get('cards').sortBy(card => card.get('order'));
  const chosen = cards.find(card => card.get('pivot_id') === chosenPivotId);

  return (
    <>
      <Label>Your hand · {cards.size}</Label>
      <Tray aria-label="Your hand">
        {cards.map(card => (
          <PlainButton
            key={card.get('pivot_id')}
            onClick={() => {
              choose(card.get('pivot_id'));
              dispatch(setContextMenu(HAND, userId));
            }}
            aria-label={card.get('name')}
          >
            <CardFace card={card} />
          </PlainButton>
        ))}
      </Tray>
      {chosen && <ContextMenu menu={HAND} userId={userId} title={chosen.get('name')}>
        <CardDetail card={chosen}>
          <HandMenu card={chosen} userId={userId} />
        </CardDetail>
      </ContextMenu>}
    </>
  );
};

Hand.propTypes = {
  userId: PropTypes.number.isRequired,
};

export default Hand;
